export default {
    CLEAR_ALL({ commit }) {
		console.log('addFamily clear', context);
    commit('CLEAR_ALL');
  },
    LOAD_ADD_SUBSCRIBER_TRANSACTION ({commit, dispatch}, transaction) {
		console.log('addFamily LOAD_ADD_SUBSCRIBER_TRANSACTION', transaction);
    return dispatch('CLEAR_ALL').then(() => {
      return commit('SET_ADD_SUBSCRIBER_TRANSACTION', transaction);
    })
  }
}